import { getValueByPath } from '../../../utils/index'
//查找树形中的指定值对应节点
export function getTreeNode(list, id, selectionKey) {
  for (const node of list) {
    if (getValueByPath(node, selectionKey) === id) {
      return node
    } else if (node.children?.length > 0) {
      const childNode = getTreeNode(node.children, id, selectionKey)
      if (childNode) {
        return childNode
      }
    }
  }
}

//返回最末级节点的ids
export function getChildNodeIds(node) {
  if (!node.children) {
    return [node.id]
  } else {
    return node.children?.reduce((pre, cur) => {
      pre.push(...getChildNodeIds(cur))
      return pre
    }, [])
  }
}
